var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5625,
    y: 0.453125,
    width: 61.2038,
    height: 61.2038,
    rx: 10.2006,
    fill: "#0B60D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5703 31.054C17.5703 24.6425 17.5703 21.4367 19.5621 19.4449C21.5539 17.4531 24.7596 17.4531 31.1711 17.4531C37.5826 17.4531 40.7885 17.4531 42.7801 19.4449C44.772 21.4367 44.772 24.6425 44.772 31.054C44.772 37.4654 44.772 40.6713 42.7801 42.663C40.7885 44.6548 37.5826 44.6548 31.1711 44.6548C24.7596 44.6548 21.5539 44.6548 19.5621 42.663C17.5703 40.6713 17.5703 37.4654 17.5703 31.054Z",
    stroke: "white",
    strokeWidth: 2.55016,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5234 36.1538L26.6548 26.7596C26.8154 26.278 27.266 25.9531 27.7737 25.9531C28.2813 25.9531 28.732 26.278 28.8925 26.7596L32.024 36.1538M25.2235 32.7535H30.3239",
    stroke: "white",
    strokeWidth: 2.55016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.125 25.9531V36.1538",
    stroke: "white",
    strokeWidth: 2.55016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3725 14.0527V17.4529M37.9733 14.0527V17.4529M31.1729 14.0527V17.4529M24.3725 44.6546V48.0548M31.1729 44.6546V48.0548M37.9733 44.6546V48.0548M48.174 37.8542H44.7737M17.5721 24.2534H14.1719M17.5721 37.8542H14.1719M17.5721 31.0538H14.1719M48.174 24.2534H44.7737M48.174 31.0538H44.7737",
    stroke: "white",
    strokeWidth: 2.55016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step3.f3b72a1498cc9fed01786c4623fab4b6.svg";
export { ForwardRef as ReactComponent };